import styled from '@emotion/styled';
import ChevronDown from '~/icons/chevron-down.svg';
import ChevronUp from '~/icons/chevron-up.svg';
import { IFacet } from '~/lib/data-contract';
import { Button } from '~/shared/components/Button/Button';
import { StyledButton } from '~/shared/components/Button/styled';

type FacetProps = IFacet & {
	onClick: (facetId: string) => void;
	expanded: boolean;
};

const StyledFacetButtonWrapper = styled.div({
	[`${StyledButton}`]: {
		'&:focus:after, &:hover:after': {
			visibility: 'hidden',
		},
	},
});

export const Facet = (props: FacetProps) => {
	const { expanded, id, label, onClick } = props;

	return (
		<StyledFacetButtonWrapper>
			<Button
				id={`tab_${id}`}
				type="button"
				variant="plain"
				onClick={() => onClick(id)}
				icon={expanded ? <ChevronUp /> : <ChevronDown />}
				role="tab"
				aria-label={label}
				aria-selected={expanded}
				aria-controls={`facet_${id}`}
			>
				{label}
			</Button>
		</StyledFacetButtonWrapper>
	);
};
